export const SWARM = {
  name: 'Swarm',
  value: 'SWARM',
};

const Basic = [SWARM];

const BasicByValue = Basic.reduce((hash, status) => {
  hash[status.value] = status;
  return hash;
}, {});

const BasicValues = Object.keys(BasicByValue);

export default {
  Basic,
  BasicByValue,
  BasicValues,

  SWARM,
};
